import { usePlayer } from '../context/PlayerContext.jsx';
import { useSettings } from '../context/SettingsContext.jsx';
import { createPortal } from 'react-dom';

// Compact now-playing bar. Shown above the bottom nav when a track is loaded,
// the user dismissed nothing, and they're not already on the Music tab.
export default function MiniPlayer({ onOpen }) {
  const { cur, playing, progress, togglePlay, next, closeMini, closed, started } = usePlayer();
  const { t } = useSettings();
  if (!cur || closed || !started) return null;

  return createPortal(
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 'var(--bottomnav-h, 56px)', zIndex: 40,
      background: 'var(--app-card,#121216)', borderTop: '1px solid #ffffff14',
      boxShadow: '0 -2px 12px #00000055',
    }}>
      {/* progress line */}
      <div style={{ height: 2, background: '#ffffff10' }}>
        <div style={{ width: `${(progress || 0) * 100}%`, height: '100%', background: 'var(--app-accent,#c9a24b)' }} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px' }}>
        <span style={{ fontSize: 18 }}>🎵</span>
        <div onClick={onOpen} style={{ flex: 1, minWidth: 0, cursor: 'pointer' }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--app-text,#ece6d6)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{cur.title}</div>
          <div style={{ fontSize: 11, color: '#8a8a92', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{cur.artist || 'Unknown'}</div>
        </div>
        <button onClick={togglePlay} aria-label={playing ? t('mp_pause') : t('mp_play')}
          style={{ background: 'transparent', border: 'none', color: 'var(--app-text,#ece6d6)', fontSize: 20, cursor: 'pointer', padding: '2px 4px' }}>
          {playing ? '⏸' : '▶'}
        </button>
        <button onClick={next} aria-label={t('mp_next')}
          style={{ background: 'transparent', border: 'none', color: 'var(--app-text,#ece6d6)', fontSize: 16, cursor: 'pointer', padding: '2px 4px' }}>
          ⏭
        </button>
        <button onClick={closeMini} aria-label={t('mp_close')}
          style={{ background: 'transparent', border: 'none', color: 'var(--app-dim,#6a6a72)', fontSize: 16, cursor: 'pointer', padding: '2px 4px' }}>
          ✕
        </button>
      </div>
    </div>,
    document.body
  );
}
